import { useState } from 'react';

import { InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const KeyNameInputDiv = styled.div`
    margin-top: 24px;
`;

const StyledTextField = styled(TextField)`
    width: 572px;
`;

interface KeyNameInputProps {
    name: string;
    handleChange: (event: any) => void;
}

const KeyNameInput: React.FC<KeyNameInputProps> = ({ name, handleChange }) => {
    const { t } = useTranslation('admin_settings');
    const [changed, setChanged] = useState<boolean>(false);

    const handleTextChange = (event) => {
        if (!changed) {
            setChanged(true);
        }
        handleChange(event);
    };

    return (
        <KeyNameInputDiv>
            <InputLabel>{t('api-keys.key-name')}</InputLabel>
            <StyledTextField
                size='small'
                name='name'
                value={name}
                onChange={handleTextChange}
                placeholder={t('example')}
                error={!name && changed}
                helperText={t('api-keys.key-name-helper')}
            />
        </KeyNameInputDiv>
    );
};

export default KeyNameInput;
